import { useSelector, shallowEqual } from 'react-redux';

// Recipe from react-redux docs: https://react-redux.js.org/api/hooks#recipe-useshallowequalselector
// This prevents unnecessary re-renders by using non-strict equality; ensures that rerenders don't happen
// when irrelevant values change
export default function useShallowEqualSelector(selector) {
    return useSelector(selector, shallowEqual);
}
